import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';

@Injectable({ providedIn: 'root' })
export class ProfileEffects {

  actions$: Actions = inject(Actions)

//   getProfileInfoOnLogin$ = createEffect(() =>
//     this.actions$.pipe(
//       ofType(loginAction),
//       concatMap((data) => {
//         return of(getProfileInfoAction({ authUid: data.user.uid }));
//       })
//     )
//   );

}
